// FUNCTIONS

// check there are no whitespaces
function isWhitespace(str) {
    return str.trim().length === 0;
}

// total color update
function updateTotal(td, total) {
    td.innerHTML = total.toFixed(3);// round to 3 decimal places
    td.style.color = "white";
    td.style.backgroundColor = "red";
    var oneHandred = 100;
    if (total.toFixed(3) === oneHandred.toFixed(3)) {
        td.style.backgroundColor = "blue";
    }
}

// calculate total value after modification
function editCell(cell) {
    var content = cell.innerHTML.trim();
    cell.classList.remove("error");
    if (isNaN(content)) {
        cell.classList.add("error");
        return;
    }
    var row = cell.parentNode;

    var total = 0;
    for (var i = 1; i < 11; i++) {
        total += parseFloat(row.cells[i].innerHTML);
    }
    updateTotal(row.cells[11], total);
    console.log("Total: " + row.cells[11].innerHTML);
}

// date format validator
function valiDate(dateInput) {
    var regex = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}\.\d{3}Z$/;
    return regex.test(dateInput);
}
// calculate total value after modification
function editCellDate(cell) {
    var dateStr = cell.innerHTML.trim();
    if (valiDate(dateStr)) {
        cell.classList.remove("error");
        cell.removeAttribute("title");

    } else {
        cell.classList.add("error");
        cell.setAttribute("title",
            "The format YYYY-MM-ddTHH:mm:SS.sssZ is an ISO 8601 formatted date string in UTC time zone."
        );
    }
}

// duplicate row function
function duplicateRow(buttonRow) {
    var row = buttonRow.closest("tr");
    var table = row.parentNode;
    var newRow = row.cloneNode(true);
    table.insertBefore(newRow, row.nextSibling);
}
// delete row function
function deleteRow(buttonRow) {
    var row = buttonRow.closest("tr");
    var table = document.getElementById("tdrTable");
    table.deleteRow(row.rowIndex);
}


// show/hide commetn text area
function toggleTextArea(columnFunction) {
    var x = columnFunction.getElementsByClassName("comment-textarea")[0];
    if (x.style.display === "none") {
        x.style.display = "block";
    } else {
        x.style.display = "none";
    }
}

// sorting date column
function sortTableDate(colIndex) {
    var table = document.getElementById("tdrTable");
    var rows = table.rows;
    var switching = true;
    var shouldSwitch = false;
    var dir = "asc"; // set initial sort direction to ascending
    var switchCount = 0;
    while (switching) {
        switching = false;
        var pos;
        for (var i = 1; i < rows.length - 1; i++) {
            shouldSwitch = false;
            var x = rows[i].getElementsByTagName("TD")[colIndex];
            var y = rows[i + 1].getElementsByTagName("TD")[colIndex];
            if (dir === "asc") {
                if (x.innerHTML.toLowerCase() > y.innerHTML.toLowerCase()) {
                    shouldSwitch = true;
                    pos = i;
                    break;
                }
            } else if (dir === "desc") {
                if (x.innerHTML.toLowerCase() < y.innerHTML.toLowerCase()) {
                    shouldSwitch = true;
                    pos = i;
                    break;
                }
            }
        }
        if (shouldSwitch) {
            rows[pos].parentNode.insertBefore(rows[pos + 1], rows[pos]);
            switching = true;
            switchCount++;
        } else {
            if (switchCount === 0 && dir === "asc") {
                dir = "desc";
                switching = true;
            }
        }
    }
    rows[0].getElementsByTagName("TD")[0].innerHTML = "<label onclick='sortTableDate(0);' class='label-td'>Date ↓</label>";
    if (dir === "asc") {
        rows[0].getElementsByTagName("TD")[0].innerHTML = "<label onclick='sortTableDate(0);' class='label-td' >Date ↑</label>";
    }

    return dir;
}
